import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs';
/**
 * Service to upload Bulkreservations
 */
@Injectable({
  providedIn: 'root'
})
export class BulkService {
/**
 * constructor
 * @param http 
 * @param environment 
 */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
/**
 * Upload a bulk of attandence to create new Reservations
 * @param date 
 * @param type 
 * @param data 
 * @param eventID 
 * @returns 
 */
  uploadBulkAttendanceList(date, type, data, eventID) {
    let body = {
      "recordDate": date,
      'input': data
    }
    if (type == 'INPUT_TYPE_CARD') {
      body["eventPublicId"] = eventID;
    } 

    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/event/attendance/bulk`, body)
      )
    )
  }
}

